<div class="container">
  <div class="container-title">Vote</div>
  <div class="container-content">
    <div class="container-paragraph">
      Clones Never Die accepts the opinions of holders. Holders can vote for directions when we run a project.
    </div>
  </div>
</div>

<style>
  .container-content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
  }

  .container-paragraph {
    width: 55%;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 768px) {
    .container-paragraph {
      align-items: center;
      width: 100%;
    }
  }
</style>
